import React, {useMemo} from 'react';
import {useTheme} from '../../theme';
import {BaseText} from './BaseText';
import {TextProps} from './types';

export const Text: React.FC<TextProps> = ({
  textColor,
  variant,
  align,
  nowrap,
  onPress,
  children,
}) => {
  const theme = useTheme();
  const typographyVariant = useMemo(
    () => theme.typography[variant || 'inline_12_default'],
    [theme.typography, variant],
  );

  return (
    <BaseText
      align={align}
      nowrap={nowrap}
      onPress={onPress}
      fontFamily={typographyVariant.fontFamily}
      fontSizePx={typographyVariant.fontSizePx}
      fontWeight={typographyVariant.fontWeight}
      lineHeightPx={typographyVariant.lineHeightPx}
      textColor={
        textColor
          ? theme.colors[textColor]
          : onPress
          ? theme.colors['content_accent_excited']
          : theme.colors[typographyVariant.textColor]
      }>
      {children}
    </BaseText>
  );
};
